export const ArrowDownIcon = ({ className = '' }) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="icons-arrows" clip-path="url(#clip0_11527_197576)">
        <path
          id="Vector"
          d="M7.95492 8.58997L12.5449 13.17L17.1349 8.58997L18.5449 9.99997L12.5449 16L6.54492 9.99997L7.95492 8.58997Z"
          fill="#1F1F1F"
        />
      </g>
      <defs>
        <clipPath id="clip0_11527_197576">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0.544922)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
